import React from 'react';
// Import tipe yang benar dari react-hook-form
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import clsx from 'clsx';

// Import tipe form utama untuk pengetikan yang kuat
import { CreateBookingFormV4 } from '../../../../services/create-booking-v4/schema/CreateBookingSchemaV4';

// Definisikan tipe untuk props dengan benar
interface CommentFormPropsV4 {
    register: UseFormRegister<CreateBookingFormV4>;
    errors: FieldErrors<CreateBookingFormV4>;
}

const CommentFormV4: React.FC<CommentFormPropsV4> = ({ register, errors }) => {
    return (
        <div className="d-flex flex-column" style={{ height: '100%' }}>
            <div className="action-sheet-content flex-grow-1">
                {/* Public Notes Section */}
                <div className="row mb-3 align-items-center">
                    <div className="col-sm-12">
                        <label htmlFor="public_note" className="col-form-label d-flex">Public Notes:</label>
                        <textarea
                            id="public_note"
                            className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.public_note })}
                            placeholder="Visible to the guest. Add any special requests or notes here."
                            style={{ height: '120px' }}
                            {...register('public_note')}
                        />
                        {errors.public_note && (
                            <span className="text-danger small mt-1">{errors.public_note.message}</span>
                        )}
                    </div>
                </div>

                {/* Private Notes Section */}
                <div className="row mb-3 align-items-center">
                    <div className="col-sm-12">
                        <label htmlFor="private_note" className="col-form-label d-flex">Private Notes:</label>
                        <textarea
                            id="private_note"
                            className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.private_note })}
                            placeholder="Internal notes for staff. Not visible to the guest."
                            style={{ height: '120px' }}
                            {...register('private_note')}
                        />
                        {errors.private_note && (
                            <span className="text-danger small mt-1">{errors.private_note.message}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentFormV4;